module.exports = __webpack_public_path__ + "static/media/Ogre Magi.33ea1f48.png";